import { Injectable } from '@angular/core';
import * as CryptoJs from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private secrectKey = 'ndjhUH#&$&298';
  constructor() { }

  encryptData(data: any) {
    const encryptedData = CryptoJs.AES.encrypt(JSON.stringify(data), this.secrectKey).toString();
    return encryptedData;
  }

  decryptData(encryptedData: string) {
    try {
      const bytes = CryptoJs.AES.decrypt(encryptedData, this.secrectKey);
      return JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
    } catch (error) {
      return null;
    }
  }
}
